
import React, { Component, Fragment } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, withRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import { hot } from 'react-hot-loader';
import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/app.scss';
import Router from './Router';
import store from './store';
import ScrollToTop from './ScrollToTop';
import { config as i18nextConfig } from '../../translations';
import ReactGA from "react-ga4";
//import username from "../Common/util";
import { userName } from '../Common/util';
/*import {useGaTracker} from 'react-ga4';
*/
/*const tracker = useGaTracker('G-KBENHXX2PE')*/

//ReactGA.initialize("G-KBENHXX2PE");
if(window.location.hostname == "jarvis.lynk.co.in"){
  ReactGA.initialize("G-DM9J4WVK04")
}else{
  ReactGA.initialize("G-KBENHXX2PE");
}


i18next.init(i18nextConfig);

var url = window.location.hostname;

class App extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      loaded: false,
    };
  }

  componentDidMount() {
    console.log("App jsx",window.location.pathname);
    ReactGA.set({ userId: "", page: window.location.pathname });
    window.addEventListener('load', () => {
      this.setState({ loading: false });
      setTimeout(() => this.setState({ loaded: true }), 10);
    });
    localStorage.setItem('url', url);
    this.unlisten = this.props.history.listen((location, action) => {
      // Call your function whenever route changes
      
      ReactGA.set({ userId: userName, page: window.location.pathname });
      //ReactGA.pageview(window.location.pathname)
      // You can put your function call here
    });
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  componentWillUnmount() {
    // Remove the listener when the component is unmounted
    this.unlisten();

  }

  render() {
    console.log("Rerendering")
    const { loaded, loading } = this.state;
    return (
      <Provider store={store}>
        {/*<BrowserRouter>*/}
          <I18nextProvider i18n={i18next}>
            <ScrollToTop>
              <Fragment>
                {!loaded
                  && (
                  <div className={`load${loading ? '' : ' loaded'}`}>
                    <div className="load__icon-wrap">
                      <svg className="load__icon">
                        <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                      </svg>
                    </div>
                  </div>
                  )
                }
                <div>
                  <Router />
                </div>
              </Fragment>
            </ScrollToTop>
          </I18nextProvider>
        {/*</BrowserRouter>*/}
      </Provider>
    );
  }
}

// Wrap the App component with withRouter to access the history prop
const AppWithRouter = withRouter(App);

export default hot(module)(() => (
  <BrowserRouter>
    <AppWithRouter />
  </BrowserRouter>
));